import React from 'react'
import Header from '../../Components/Header'
import Opportunity from '../../Components/Opportunity/Opportunity'
import Sidebar from '../../Components/Sidebar'
import SingleSignOnSideBar from '../../Components/SingleSignOnSideBar'

function OpportunityPage() {
  return (
    <>
    <Header/>
    {/* <Sidebar/> */}
    <SingleSignOnSideBar/>
    <Opportunity/>
    </>
  )
}

export default OpportunityPage